import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
import StarRating from "react-star-ratings";
import EditIcon from "../../assets/images/edit-icon.png";
import { Button } from "../Button/Button.jsx";
import classes from "./confirmbookinglessoncard.module.css";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import {
  CalendarIconGray,
  coachDemoImg,
  LocationIconGray,
  ClockIconGray,
  ApplePayBlack,
  EditIconGray,
  ApplePayDisabled,
} from "../../constant/imagePath";
import { ReactSVG } from "react-svg";

export const ConfirmBookingLessonCard = ({
  data,
  disabled,
  onClickApplePay,
  onClickProceedWithPayment,
  checkBoxState,
  cardNumber,
  cardholderName,
  expiryDate,
  cvc,
  paymentDetailsRadioState,
  fullName,
  ageState,
  phoneNumber,
  checkBoxState1,
  setIsCancellationModalOpen,
  setIsRequirementsModalOpen,
  setIsBookingRequestedModalOpen,
  setIsErrorOccurenceModalOpen,
}) => {
  return (
    <div
      className={`${[classes.lessonCard].join(" ")}`}
      style={{ boxShadow: `0px 4px 27px ${Colors.boxShadow}` }}
    >
      <Row className="g-0">
        <Col md={12} className="d-flex">
          <div>
            <img
              src={data?.userData?.photo}
              className={`${[classes.profile].join(" ")}`}
            />
          </div>
          <div className={classes.headingWithRatingAndReviews}>
            <h5 className={classes.mainHeading}>
              <span style={{ color: Colors.neutralShadesOfNero, ...Fonts.h5 }}>
                {data?.userData?.displayName?.split(" ")[0]}
              </span>
              <span style={{ color: Colors.neutralShadesOfNero, ...Fonts.h5 }}>
                {data?.userData?.displayName?.split(" ")[1]}
              </span>
            </h5>
            <div className={` ${[classes.userDetails].join(" ")}`}>
              <p className={classes.ratingStar}>
                <StarRating
                  starRatedColor={Colors.mainShadeOfRed}
                  starEmptyColor={Colors.neutralShadesOfDimGray}
                  rating={data?.userData?.rating / 5}
                  starDimension={"16px"}
                  numberOfStars={1}
                />
              </p>
              <span
                className={`${[classes.rating].join(" ")}`}
                style={{
                  color: Colors.neutralShadesOfNero,
                  ...Fonts.p2,
                  fontFamily: "inter-600",
                }}
              >
                {data?.userData.rating?.toFixed(1)}
              </span>
              <a
                className={`${[classes.reviews].join(" ")}`}
                style={{
                  color: Colors.neutralShadesOfDimGray,
                  ...Fonts.p4,
                }}
              >
                ({data?.userData?.reviews?.length} reviews)
              </a>
              <span
                className={`${[classes.break].join(" ")}`}
                style={{
                  backgroundColor: Colors.neutralShadesOfPinkSwan,
                }}
              />

              <span style={{ color: Colors.neutralShadesOfNero, ...Fonts.h9 }}>
                {data?.userData.sport}
              </span>
            </div>
          </div>
        </Col>

        <Col
          md={12}
          className={`${[classes.borderBottom].join(" ")}`}
          style={{
            borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
          }}
        />
        {/* Lesson Details */}
        <Col md={12}>
          <div className={`${[classes.headingAndText].join(" ")}`}>
            <h5 style={{ color: Colors.neutralShadesOfNero, ...Fonts.h5 }}>
              Lesson details
            </h5>
            <span>
              <ReactSVG
                src={EditIconGray}
                onClick={() => setIsErrorOccurenceModalOpen(true)}
                beforeInjection={(svg) => {
                  svg.classList.add(classes.editIcon);
                }}
              />
            </span>
          </div>
        </Col>
        <Col md={12}>
          <ul className={`${[classes.lessonDetails]}`}>
            <li>
              <ReactSVG src={CalendarIconGray} />
              <span style={{ color: Colors.neutralShadesOfNero, ...Fonts.p1 }}>
                {data?.date}
              </span>
            </li>
            <li>
              <ReactSVG src={ClockIconGray} />
              <span style={{ color: Colors.neutralShadesOfNero, ...Fonts.p1 }}>
                {data?.startTime} - {data?.endTime}
              </span>
            </li>
            <li>
              <ReactSVG src={LocationIconGray} />
              <span style={{ color: Colors.neutralShadesOfNero, ...Fonts.p1 }}>
                {data?.location}
              </span>
            </li>
          </ul>
        </Col>
        <Col
          md={12}
          className={`${[classes.borderBottom].join(" ")}`}
          style={{
            borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
          }}
        />
        {/* Lesson Price */}
        <Col md={12}>
          <div className={`${[classes.headingAndText].join(" ")}`}>
            <h5 style={{ color: Colors.neutralShadesOfNero, ...Fonts.h5 }}>
              Lesson price
            </h5>
            <span
              className={`${[classes.price].join(" ")}`}
              style={{ color: Colors.neutralShadesOfNero, ...Fonts.h5 }}
            >
              ${data?.price}
            </span>
          </div>
          <p
            className={`${[classes.terms].join(" ")}`}
            style={{ color: Colors.neutralShadesOfDimGray, ...Fonts.p2 }}
          >
            By clicking the button below I accept Lytesnap’s terms of use
          </p>
        </Col>
        <Col md={12}>
          <Button
            disabled={disabled}
            onClick={onClickApplePay}
            size={"Large"}
            primary={false}
            customStyle={{
              padding: "18px 32px",
              ...Fonts.b2,
            }}
            label={
              <span
                style={{
                  ...Fonts.h8,
                }}
                className={classes.btn1Label}
              >
                Pay using{" "}
                <ReactSVG
                  src={disabled == true ? ApplePayDisabled : ApplePayBlack}
                  beforeInjection={(svg) => {
                    svg.classList.add(classes.applePayIcon);
                  }}
                />{" "}
                Pay
              </span>
            }
          />
          {(checkBoxState &&
            checkBoxState[0] ===
              "Save payment information to my account for future purchases" &&
            cardNumber !== "" &&
            cardholderName !== "" &&
            expiryDate !== "" &&
            cvc !== "") ||
          (checkBoxState1 &&
            checkBoxState1[0] ===
              "Save payment information to my account for future purchases" &&
            fullName !== "" &&
            ageState !== "" &&
            phoneNumber !== "") ? (
            <Button
              onClick={onClickProceedWithPayment}
              primary={true}
              disabled={disabled}
              label={"Proceed with payment"}
              size={"Large"}
              customStyle={{
                padding: "12px 32px",
                ...Fonts.b1,
                marginTop: "12px",
              }}
            />
          ) : (
            <Button
              onClick={onClickProceedWithPayment}
              primary={false}
              disabled={disabled}
              label={"Proceed with payment"}
              size={"Large"}
              customStyle={{
                padding: "12px 32px",
                ...Fonts.b1,
                marginTop: "12px",
              }}
            />
          )}
        </Col>
      </Row>
    </div>
  );
};

ConfirmBookingLessonCard.propTypes = {
  data: PropTypes.object,
  disabled: PropTypes.bool,
  onClickApplePay: PropTypes.func,
  onClickProceedWithPayment: PropTypes.func,
};
ConfirmBookingLessonCard.defaultProps = {
  data: {
    userData: {
      displayName: "Micheal Baumgardner",
      photo: coachDemoImg,
      rating: 5,
      sport: "Tennis coach",
      reviews: [{}, {}, {}, {}, {}, {}, {}],
    },
    price: 85,
    date: "Aug 12, 2021",
    startTime: "12:30PM",
    endTime: "2:30PM",
    location: "DeWitt Clinton Park, W 54th St, New York, NY",
  },
  disabled: false,
  onClickApplePay: () => {},
  onClickProceedWithPayment: () => {},
};
